import { render } from "./TheBanner.vue?vue&type=template&id=a2f9ad50&scoped=true"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"

import "./TheBanner.vue?vue&type=style&index=0&id=a2f9ad50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f9ad50"]])

export default __exports__